import Layout from '@layout/Index'

export const workInfoBusinessType = [
  {
    path: '/work-info-business-type',
    component: Layout,

    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "WorkInfoBusinessTypeTable" */ './pages/WorkInfoBusinessTypeTable.vue'),
        name: '职业信息行业',
        meta: {
          title: '职业信息行业',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "WorkInfoBusinessTypeForm" */ './pages/WorkInfoBusinessTypeForm.vue'),
        name: '新增职业信息行业',
        meta: {
          title: '新增职业信息行业',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "WorkInfoBusinessTypeForm" */ './pages/WorkInfoBusinessTypeForm.vue'),
        name: '编辑职业信息行业',
        meta: {
          title: '编辑职业信息行业',
        },
      },
      {
        path: 'batch-jobs',
        component: () => import(/* webpackChunkName: "WorkInfoBatchJobsTable" */ './pages/WorkInfoBatchJobsTable.vue'),
        name: '职业信息批量任务',
        meta: {
          title: '职业信息批量任务',
        },
      },
    ],
  },
]




// WEBPACK FOOTER //
// ./src/views/work-info-business-type/work-info-business-type.route.js